import {
  ComponentWithAs,
  mergeStyles,
  Provider,
  ProviderProps,
  teamsDarkV2Theme,
} from "@fluentui/react-northstar";

import { fluentProviderStyles } from "./FluentProvider.styles";

export const FluentProvider: ComponentWithAs<
  keyof JSX.IntrinsicElements,
  ProviderProps
> = ({ styles, ...rest }: ProviderProps) => (
  <Provider
    theme={teamsDarkV2Theme}
    styles={mergeStyles(styles ?? {}, fluentProviderStyles)}
    {...rest}
  />
);
